import React from 'react'
import { helpers, prismicHelpers } from '../../helpers'
import { ThemeOverride, Container } from '../core'
import { SinceLogo } from '../core/icons'
import { Columns } from '../bulma'
import FooterTopContent from './FooterTopContent'
import FooterBottomContent from './FooterBottomContent'
import FooterColumn from './FooterColumn'

/**
* Main Site Footer component.
*/
class Footer extends React.Component {
  constructor(props) {
    super(props)

    this.uid = helpers.generateID('ft')

    this.renderColumns = this.renderColumns.bind(this)
  }

  /**
  * Renders all the columns in the footer. Filters only the columns that
  * the user has permission to see.
  */
  renderColumns() {
    const isInverted = this.props.data.useCustomTheme !== 'yes' || this.props.data.textColor !== 'dark'

    return this.props.data.columns
      .filter(column => prismicHelpers.userHasPermission(column))
      .map((column, idx) => <FooterColumn column={column.column} key={idx} isInverted={isInverted} />)
  }

  render() {
    // Filter the links the user has access to in the bottom section.
    const bottomLinks = this.props.data.bottomLinks
      .filter(item => prismicHelpers.userHasPermission(item))


    // Figure out classes and theme settings.

    const useCustomTheme = this.props.data.useCustomTheme === 'yes'


    const isInverted = !useCustomTheme || this.props.data.textColor !== 'dark'


    const classes = [
      'site-footer',
      isInverted ? 'is-inverted' : '',
      'can-override-background-color',
      'can-override-background-image',
      'hidden-print',
    ]

    const footerStyles = {}

    if (useCustomTheme && this.props.data.backgroundColor) {
      footerStyles.backgroundColor = `#${this.props.data.backgroundColor}`
    }

    if (useCustomTheme && this.props.data.backgroundImage) {
      footerStyles.backgroundImage = this.props.data.backgroundImage.url
    }

    return (
      <footer id={this.uid} className={classes.join(' ')}>
        <ThemeOverride
          selector={`#${this.uid}`}
          values={footerStyles}
          choices={{
            backgroundColor: Boolean(footerStyles.backgroundColor),
            backgroundImage: Boolean(footerStyles.backgroundImage),
          }}
        />
        <FooterTopContent />
        <section className="main-content">
          <Container>
            <Columns isMobile isMultiline>
              { this.renderColumns() }
            </Columns>
          </Container>
          <SinceLogo />
        </section>
        <FooterBottomContent items={bottomLinks} isInverted={isInverted} />
      </footer>
    )
  }
}

export default Footer
